module.exports = __webpack_public_path__ + "media/images/team/stephan-37c78efc9c9a84952a21d949988facf7.jpg";